'use client';
import React from 'react';
import animationData from './spinner.json';
import type LottieType from 'react-lottie-player';

export const Loading: React.FC = () => {
  const [Lottie, setLottie] = React.useState<typeof LottieType | null>(null);

  React.useEffect(() => {
    import('react-lottie-player').then((mod) => setLottie(() => mod.default));
  }, []);

  return Lottie ? (
    <div className="relative mx-auto my-48 size-16 [&_svg]:size-full">
      <Lottie loop animationData={animationData} play />
    </div>
  ) : null;
};
